<section class="section-lg trustedby">
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <h3>深受全球領導品牌肯定</h3>
            </div>
            <div class="col-12">
                <div class="glide" id="leadersSlider" *ngIf="isBrowser">
                    <div class="glide__track" data-glide-el="track">
                      <ul class="glide__slides">
                        <li class="glide__slide clientLogo" *ngFor="let logo of clientLogos">
                          <img [src]="logo.src" [alt]="logo.alt" [width]="logo.width" [height]="logo.height" [class]="logo.class">
                        </li>
                      </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>